import { Service, signal, afterNextRender, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent, tap } from 'rxjs';

@Service()
export class WindowService {
    private destroyRef = inject(DestroyRef);

    readonly scrollTop = signal(0);
    readonly scrolled = signal(false);

    constructor() {
        afterNextRender(() => {
            const main = document.querySelector('main');
            if (!main) {
                return;
            }

            this.update(main);

            fromEvent(main, 'scroll', { passive: true })
                .pipe(
                    tap(() => this.update(main)),
                    takeUntilDestroyed(this.destroyRef),
                )
                .subscribe();

            requestAnimationFrame(() => this.update(main));
        });
    }

    private update(el: Element): void {
        const top = el.scrollTop;
        this.scrollTop.set(top);
        this.scrolled.set(top > 0);
    }
}
